<template>
    <ul class="ui-stringlist">
        <li v-for="record in records" :key="record.id" class="ui-stringlist__row">
            <input
              type="text"
              class="i-main-style"
              :value="record.value"
              @change="onValueChange($event, record.id)"
              @input="onValueChange($event, record.id)"
              :maxlength="maxlength"
              :disabled="disabled"
             >
            <a class="link-delete-row"
               v-if="!disabled"
               @click="onRemoveClick($event, record.id)"
            ></a>
        </li>
        <li class="ui-stringlist__row" v-if="!disabled">
            <a class="ui-stringlist__add add-t-r" @click="onAddClick($event)"></a>
        </li>
    </ul>
</template>

<script>
export default {
    name: "UiStringlist",
    props: ["records", "disabled", "maxlength"],
    methods: {
        onAddClick ($event) {
            $event.preventDefault();
            this.$emit('add');
        },
        onValueChange($event, id) {
            this.$emit('change', id, $event.currentTarget.value);
        },
        onRemoveClick($event, id) {
            $event.preventDefault();
            this.$emit('remove', id);
        }
    }
}
</script>

<style scoped>
.ui-stringlist {
    list-style: none;
    padding-left: 0;
    min-width: 200px;
    margin: 0;
}

.ui-stringlist__row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.ui-stringlist__row + .ui-stringlist__row {
    margin-top: 8px;
}

.ui-stringlist__add {
    transform: translateX(-3px);
}
</style>
